<div *ngIf="!sharedService.isStaticHtml && !sharedService.isVendorLoginUrl && !maintenanceModeOn"
[class.not-logged-in]="sessionService.userRole !== 'GUEST' && !topService.isMobile"
[class.not-logged-in-mobile]="sessionService.userRole !== 'GUEST' && topService.isMobile">
    <app-top-categories *ngIf="!topService.isMobile"></app-top-categories>
</div>
<div *ngIf="maintenanceModeOn && !sharedService.isStaticHtml" class="maintenance-wrapper" [class.mobile]="topService.isMobile">
  <app-maintenance></app-maintenance>
</div>
